import { takeLatest, put } from 'redux-saga/effects';
import _get from 'lodash/get';

import api from '../../../utils/apiConfig';
import UrlConfig from '../../../utils/urlHelper';
import { TXN_OVERVIEW, FETCH_TRANSACTIONS } from './constants';
import { setTxnOverview, setTxnDetails } from './actions';

interface Url {
  fetchTxnOverview: Function;
  transactionDetail: Function;
  downloadTransactions: Function;
  downloadAllTransactions: Function;
}

const urlHelper: Url = UrlConfig;

function* fetchTxnOverview(action: any) {
  try {
    const response = yield api.get(
      urlHelper.fetchTxnOverview(action.id, action.fromTime, action.toTime, action.txnType),
    );
    const responseData = response.data;
    if (responseData.success) {
      yield put(setTxnOverview(_get(responseData, 'data', {})));
    } else {
      yield put(setTxnOverview({}));
    }
  } catch (e) {
    yield put(setTxnOverview({}));
  }
}

function* fetchTransactions(action: any) {
  const { data } = action;
  try {
    const response = yield api.get(urlHelper.transactionDetail(data.query, data.param));
    const responseData = response.data;
    if (responseData.success) {
      const response = _get(responseData, 'data', []);
      yield put(setTxnDetails({ ...response, reset: data.reset, vehicleNum: data.vNum }));
    } else {
      yield put(setTxnDetails({}));
    }
  } catch (e) {
    yield put(setTxnDetails({}));
  }
}

function* mySaga() {
  yield takeLatest(TXN_OVERVIEW, fetchTxnOverview);
  yield takeLatest(FETCH_TRANSACTIONS, fetchTransactions);
}

export default mySaga;
